// eslint-disable-next-line no-restricted-imports
import { createRouter, createWebHistory } from 'vue-router'

import { addRouterNavigationGuards } from './router-utils.ts'
import { routes } from './routes.ts'

export const routerInstance = createRouter({
  history: createWebHistory(),
  routes,
})

addRouterNavigationGuards(routerInstance)
